<template>

  <div class="product-card-500-wrapper border rounded shadow-sm">

    <div class="text-center product-card-500-wrapper-height text-dark  p-2 pt-4">
      <h5 class="product-card-500-name">{{ product.name }}</h5>

      <template v-if="product.price > 0">
        <div class="product-card-500-offer-section" v-if="product.offer > 0 ">

          <h6 class="product-card-500-offer-section-text">
            <del
                v-html="$t('price.price',{currency:formatNumber(product.price)})"
            />
          </h6>
          <h6 class="product-card-500-offer-section-value"
              v-html="$t('price.price',{currency:formatNumber(parseInt(product.price) - parseInt(product.offer))})"

          >

          </h6>
        </div>
        <h6 class="product-card-500-offer-section-price" v-else
            v-html="$t('price.price',{currency:formatNumber(product.price)})"
        >
        </h6>
      </template>

      <div class="col-12">
        <div
            class="row justify-content-around align-items-center align-baseline product-card-500-quantity-manager-wrapper">
          <m-product-card-quantity-manager1 :in-active-quantity-manager="inActiveQuantityManager"
                                            :setUnauthenticatedShoppingCartFromLoginUser="true"
                                            :redirect-after-add-digital-product="true"
                                            :show-modal-if-product-category-inside-cash-on-delivery="true"
                                            class="product-card-500-quantity-manager my-1"
                                            :product="product"/>

        </div>
      </div>


      <p v-html="product.description"></p>
    </div>

    <div class="product-card-500-bottom">

      <SingleProductTableFeature1 :active-feature-links="false" :product="product"/>
      <div class="col-12">
        <div
            class="row justify-content-around align-items-center align-baseline product-card-500-quantity-manager-wrapper">
          <m-product-card-quantity-manager1 :in-active-quantity-manager="inActiveQuantityManager"
                                            :setUnauthenticatedShoppingCartFromLoginUser="true"
                                            :redirect-after-add-digital-product="true"
                                            :show-modal-if-product-category-inside-cash-on-delivery="true"
                                            class="product-card-500-quantity-manager my-1"
                                            :product="product"/>

        </div>
      </div>

    </div>
  </div>


</template>

<script>
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import mA from '../../../Tags/A.vue'
import mImg from '../../../Tags/Img.vue'
import {OfferProps} from "../../../Product/ProductOffer/ProductOfferProps";
import VariationProduct from "./../../SingleProductPrice3/VariationProduct.vue";
import {productFeatureName, productFeatureSubProduct} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product'
import mShoppingCartQuantityManager1 from "../../ShoppingCartQuantityManager1.vue";
import ProductCardPrice200 from "./../../ProductCardPrice200/ProductCardPrice200.vue";
import SingleProductPrice3 from "./../../SingleProductPrice3/SingleProductPrice3.vue";
import ProductCard313PriceManager from "./ProductCard500PriceManager.vue";
import mCard314 from "../../../Cards/Card314.vue";
import mProductCardQuantityManager1 from "../../QuantityManager/Card/ProductCardQuantityManager1.vue";
import mIcon from "../../../Icons/Icon.vue";
import SingleProductTableFeature1 from "../../Single/Components/SingleProductTableFeature1.vue";

export default {
  name: "ProductCard208",
  components: {
    SingleProductTableFeature1,
    mIcon, mProductCardQuantityManager1,
    ProductCard313PriceManager,
    SingleProductPrice3,
    ProductCardPrice200,
    mShoppingCartQuantityManager1,
    VariationProduct,
    mA,
    mImg,
    mCard314
  },
  props: {
    product: {},
    ...OfferProps,
  },
  data() {
    return {
      selectedVariation: null,
      selectedVariationObject: {},
    }
  },
  methods: {
    formatNumber,
    productFeatureName,
    productFeatureSubProduct,
    selectVariation(product, feature) {
      this.selectedVariation = feature.id
      this.selectedVariationObject = feature
    },
  },
}

</script>

<style scoped>

.product-card-313 :deep(img) {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.product-card-500-wrapper-height {
  height: 200px;
}
</style>